export enum SearchType {
    DEFAULT = 'default',
    ADVANCE = 'advance',
}

export enum TicketApiType {
    LIST = 'list',
    DEFAULTLIST = 'defaultList',
    FILTEREDLIST = 'filteredList',
}

export const DEFAULT_PAYLOAD = {
    ticketSubject: '',
    ticketComments: '',
    requestedByName: '',
    requestedBy: '',
    ticketQueues: '',
    ticketPriority: '',
    assignee: '',
    assigneeId: '',
    requestedBytagId: '',
    isReportPageCall: '',
    ticketNumber: '',
    submittedBefore: '',
    submittedAfter: '',
    ticketStatus: '',
    taskStatus: '',
    assignedToMe: false,
    unClaimedTicket: false,
    roleId: '',
    requester: '',
    userRole: '',
    archiveFlagValue: false,
    customFieldSelect: -1,
    customFieldSelectVal: '',
    ticketCategorySelect: -1,
    ticketType: '',
    filterticketStatus: '',
    userticketQueues: '',
    userFilter: '',
    pageNumber: '',
    sortBy: '',
    sortOrder: '',
    csrftoken: '',
};

export const workgroupOptions = [{ value: '', text: 'Any' }];

export const ticketStatusOptions = [
    { value: '', text: 'Any' },
    { value: 'Awaiting_Internal', text: 'Awaiting Internal' },
    { value: 'Awaiting_Requestor', text: 'Awaiting Requestor' },
    { value: 'Canceled', text: 'Canceled' },
    { value: 'Open', text: 'Open' },
    { value: 'UnClaimed', text: 'Unclaimed' },
    { value: 'Resolved', text: 'Resolved' },
];

export const ticketStatusAdvanceOptions = [
    { key: 'Awaiting_Internal', value: 'Awaiting Internal' },
    { key: 'Awaiting_Requestor', value: 'Awaiting Requestor' },
    { key: 'Canceled', value: 'Canceled' },
    { key: 'Open', value: 'Open' },
    { key: 'Resolved', value: 'Resolved' },
    { key: 'UnClaimed', value: 'Unclaimed' },
];

export const ticketPriorityOptions = [
    { key: 'Critical', value: 'Critical' },
    { key: 'High', value: 'High' },
    { key: 'Medium', value: 'Medium' },
    { key: 'Low', value: 'Low' },
];

export const ticketAssignmentOptions = [
    { value: 'myWorkgroupFilter', text: 'Any in my workgroups' },
    { value: 'createdByMeFilter', text: 'Created by me' },
    { value: 'assignedToMeFilter', text: 'Assigned to me' },
];

export enum DefaultDropdownType {
    WORKGROUP = 'workgroup',
    TICKET_STATUS = 'ticketStatus',
    TICKET_ASSIGNMENT = 'ticketAssignment',
}

export const defaultSearchValue = {
    workgroup: 'Any',
    ticketStatus: 'Open',
    ticketAssignment: 'assignedToMeFilter',
};

export const advanceSearchValue = {
    ticketQueues: [],
    ticketStatus: [],
    ticketAssignment: 'assignedToMeFilter',
    ticketSubject: '',
    ticketComments: '',
    ticketPriority: [],
    ticketNumber: '',
    submittedAfter: '',
    submittedBefore: '',
    assignee: '',
    assigneeId: '',
    assigneeByTag: '',
    requestedBy: '',
    requestedByName: '',
    requestedBytagId: '',
    createdForRole: '',
    requester: '',
    roleId: '',
    customFieldSelect: '',
    customFieldSelectVal: '',
    ticketCategorySelect: '',
    ticketType: [],
    workGroupBytagId: '',
};

export const markAsDocumentOptions = [
    { value: '', text: 'Select' },
    { value: 'accepted', text: 'Accepted' },
    { value: 'rejected', text: 'Rejected' },
];

export const rejectReasonOptions = [
    { value: '', text: 'Select' },
    {
        value: 'Invalid document - Doesn\'t match application',
        text: 'Invalid document - Doesn\'t match application',
    },
    {
        value: 'Invalid document - More recent document required',
        text: 'Invalid document - More recent document required',
    },
    {
        value: 'Invalid document - Not applicable',
        text: 'Invalid document - Not applicable',
    },
    {
        value: 'Invalid document - Unreadable',
        text: 'Invalid document - Unreadable',
    },
];

export const CANCEL_REASON_MAX_LENGTH = 100;
export const CANCEL_REASON_COLS = 40;
export const CANCEL_REASON_ROWS = 4;

export const COMPLETE_INTERNAL_COMMENT_MAX_LENGTH = 1999;
export const COMPLETE_INTERNAL_COMMENT_COLS = 200;
export const COMPLETE_INTERNAL_COMMENT_ROWS = 7;

export const VERIFY_COMPLETE_INTERNAL_COMMENT_MAX_LENGTH = 1999;
export const VERIFY_COMPLETE_INTERNAL_COMMENT_COLS = 200;
export const VERIFY_COMPLETE_INTERNAL_COMMENT_ROWS = 7;

export const VERIFY_COMPLETE_EXTERNAL_COMMENT_MAX_LENGTH = 1999;
export const VERIFY_COMPLETE_EXTERNAL_COMMENT_COLS = 200;
export const VERIFY_COMPLETE_EXTERNAL_COMMENT_ROWS = 7;

export enum customFieldTypes {
    TEXT_BOX = 'TEXT_BOX',
    OPTION_LIST = 'OPTION_LIST',
    DATE_INPUT = 'DATE_INPUT',
}

export const CustomFiedType = [customFieldTypes.TEXT_BOX, customFieldTypes.OPTION_LIST, customFieldTypes.DATE_INPUT];

export const pendingReport = 'ticket/pendingreport';

export const defaultOptions = [{ value: '', text: 'Select' }];

export enum popoverActions {
    CLAIM = 'claim',
    COMPLETE = 'complete',
    REASSIGN = 'Reassign',
    ASSIGN = 'Assign',
}

export enum permissions {
    TKM_WORKFLOW_VERIFY = 'TKM_WORKFLOW_VERIFY',
}

export const reopenNotAllowedWorkgroup = [
    'Document Verification Workgroup',
    'DMI Workgroup',
    'Qle Validation Workgroup',
];

export enum CompleteTicketAction {
    INTERNAL = 'internal',
    REQUESTOR = 'requestor',
    CLAIM = 'claim',
    COMPLETE = 'complete',
}

export enum validateTypes {
    Y = 'Y',
    N = 'N',
}

export enum ticketCategoryOptions {
    DOCUMENT_VERIFICATION = 'Document Verification',
    QLE = 'QLE',
}

export enum taskStatusTypes {
    CLAIMED = 'Claimed',
    UNCLAIMED = 'UnClaimed',
    REOPENED = 'Reopened',
    RESTARTED = 'Restarted',
    CANCELED = 'Canceled',
    OPEN = 'Open',
    RESOLVED = 'Resolved',
}

export enum ticketStatusTypes {
    OPEN = 'Open',
    RESOLVED = 'Resolved',
    CANCELED = 'Canceled',
    COMPLETED = 'Completed',
    UNCLAIMED = 'Unclaimed',
}

export enum booleanTypes {
    TRUE = 'true',
    FALSE = 'false',
}

export const AUTOCOMPLETE_DEBOUNCE_DELAY = 300;
export const AUTOCOMPLETE_MIN_SEARCH_QUERY_LENGTH = 2;


